import { isEmpty } from '@ember/utils';

import { Transform } from '@warp-drive/legacy/serializer/transform';
import { TrackedArray } from 'tracked-built-ins';

export default class ArrayTransform extends Transform {
  deserialize(serialized = []) {
    serialized = isEmpty(serialized) ? [] : serialized;
    return new TrackedArray(serialized);
  }

  serialize(deserialized = []) {
    return isEmpty(deserialized) ? [] : deserialized;
  }
}
